var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnDestroy, OnInit } from '@angular/core';
import { AppinfoService } from 'app/services/appinfo.service';
import { MainDataService } from 'app/services/main-data.service';
import { InterlayerReportService } from 'app/services/interlayer-report.service';
import { TooltipHelpService } from 'app/services/tooltip-help.service';
import { CommonFunctionService } from 'app/services/common-function.service';
var TabReportFiltersComponent = /** @class */ (function () {
    function TabReportFiltersComponent(appinfoService, commonService, reportService, mainDataService, tooltipHelpService) {
        this.appinfoService = appinfoService;
        this.commonService = commonService;
        this.reportService = reportService;
        this.mainDataService = mainDataService;
        this.tooltipHelpService = tooltipHelpService;
        this.filterOptions = [];
        this.isGenerating = false;
    }
    TabReportFiltersComponent.prototype.generate = function () {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isGenerating = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.reportService.qrInterlayer(this.selectedReportType.value, this.mainDataService.modelBS.getValue())];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        console.log(err_1);
                        return [3 /*break*/, 4];
                    case 4:
                        this.isGenerating = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    TabReportFiltersComponent.prototype.onSelectReportType = function () {
        return __awaiter(this, void 0, void 0, function () {
            var spinnerId, reportType, reports, err_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        spinnerId = this.commonService.getRandomId();
                        this.commonService.setLoadingSpinner(true, spinnerId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        reportType = this.selectedReportType.value === 'ALL' ? null : this.selectedReportType.value;
                        return [4 /*yield*/, this.reportService.getQrReportTabs(reportType)];
                    case 2:
                        reports = _a.sent();
                        //
                        this.reportService.reportListBS.next({
                            reportType: this.selectedReportType.value,
                            list: reports
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _a.sent();
                        console.log(err_2);
                        return [3 /*break*/, 4];
                    case 4:
                        this.commonService.setLoadingSpinner(false, spinnerId);
                        return [2 /*return*/];
                }
            });
        });
    };
    TabReportFiltersComponent.prototype.toggleFilterOption = function (option) {
        this.reportService.reportFilterInfoBS.next({
            filterOptions: this.filterOptions,
            source: 'filterTabToggle'
        });
        this.reportService.requestData.next();
    };
    TabReportFiltersComponent.prototype.onMouseoverCode = function (option) {
        var _this = this;
        this.mouseoverCodeTimeout = setTimeout(function () {
            var codes = [option.value];
            _this.tooltipHelpService.lastTooltipsBS.next({
                codes: codes
            });
        }, this.tooltipHelpService.delayTime);
    };
    TabReportFiltersComponent.prototype.onMouseoutCode = function () {
        if (this.mouseoverCodeTimeout) {
            clearTimeout(this.mouseoverCodeTimeout);
        }
    };
    TabReportFiltersComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.reportTypes = this.appinfoService.reportTypeList;
                        this.selectedReportType = this.reportTypes[0];
                        return [4 /*yield*/, this.onSelectReportType()];
                    case 1:
                        _a.sent();
                        this.filterOptionsSub = this.reportService.reportFilterInfoBS.subscribe(function (data) {
                            if (data.source !== 'filterTabToggle') {
                                _this.filterOptions = data.filterOptions;
                            }
                        });
                        this.selectedReportSub = this.reportService.selectedReportBS.subscribe(function (data) {
                            _this.selectedReport = data;
                        });
                        // Update report list on qc finishing
                        this.qrFinishSub = this.reportService.onQrFinish.subscribe(function () { return __awaiter(_this, void 0, void 0, function () {
                            var spinnerId, err_3;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        spinnerId = this.commonService.getRandomId();
                                        this.commonService.setLoadingSpinner(true, spinnerId);
                                        _a.label = 1;
                                    case 1:
                                        _a.trys.push([1, 3, , 4]);
                                        return [4 /*yield*/, this.onSelectReportType()];
                                    case 2:
                                        _a.sent();
                                        return [3 /*break*/, 4];
                                    case 3:
                                        err_3 = _a.sent();
                                        console.log(err_3);
                                        return [3 /*break*/, 4];
                                    case 4:
                                        this.commonService.setLoadingSpinner(false, spinnerId);
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    TabReportFiltersComponent.prototype.ngOnDestroy = function () {
        this.filterOptionsSub.unsubscribe();
        this.selectedReportSub.unsubscribe();
        this.qrFinishSub.unsubscribe();
    };
    return TabReportFiltersComponent;
}());
export { TabReportFiltersComponent };
